export default __webpack_public_path__ + "static/media/topology.f7a34dc6.jpeg";